// extracted by css-extract-rspack-plugin
export default {"root":"PFr1t","selfCenter":"IZjip","label":"spU_T","invalid":"iKAf5","labelError":"XDYEs","infoIcon":"RGAFE"};